<script setup>
import { Button, ActionSheet } from 'vant'
import { watchEffect, ref } from 'vue'
import { useRoute } from 'vue-router'
import qs from 'qs'
import { getAnswerStatistics, getAnswerStatisticsTotal } from '@/api/admin'
import Pie from '@/components/echarts/Pie.vue'
import TotalStatistics from './TotalStatistics.vue'
import DataDetailList from './DataDetailList.vue'
import DataStatisticsItem from './DataStatisticsItem.vue'

const props = defineProps({
  formTree: {
    type: Object,
    default: () => {},
  },
  chartType: Number,
  formDate: Object,
})

// 当前需要展示的填空题详细信息的key
const currentDetailItemKey = ref('')
const currentDetailType = ref('')
// 是否显示填空题的更多信息
const showActionSheet = ref(false)
const handleShowActionSheetClick = (item) => {
  currentDetailItemKey.value = item.optionVoList[0].optionKey
  currentDetailType.value = item.questionType
  showActionSheet.value = true
}

const dataList = ref([])
const route = useRoute()

// 全部统计数据
const totalDataList = ref([])
// 获取总的统计数据
const fetchTotalStatic = async () => {
  const res = await getAnswerStatisticsTotal({
    questionActiveKey: route.query.questionActiveKey,
    totalType: 1,
    totalType: props.chartType,
    ...props.formTree,
    ...props.formDate,
  })

  if (res.ok) {
    totalDataList.value = res.data
  }
}

// 获取每道题的统计数据
const fetchStatic = async () => {
  const res = await getAnswerStatistics(
    qs.stringify({
      questionActiveKey: route.query.questionActiveKey,
      ...props.formTree,
      pageNo: 1,
      pageSize: 10,
      ...props.formDate,
    })
  )

  if (res.ok) {
    dataList.value = res.data?.rows || []
  }
}

watchEffect(() => {
  fetchTotalStatic()
  fetchStatic()
})
</script>
<template>
  <!-- 列表 -->
  <ul class="list-wrap">
    <h2 v-if="chartType === 0" class="list-title">
      填报情况统计
      <span v-if="totalDataList?.[0]?.submitCount !== undefined"
        >(已填报{{ totalDataList?.[0]?.submitCount }}条)</span
      >
    </h2>
    <TotalStatistics :dataList="totalDataList" :chartType="chartType" />
    <h2 class="list-title">问题统计分析</h2>
    <DataStatisticsItem
      v-for="(item, index) in dataList"
      :item="item"
      :index="index"
      @showActionSheet="handleShowActionSheetClick"
    />
  </ul>
  <ActionSheet
    style="z-index: 999999999999"
    v-model:show="showActionSheet"
    title="详细信息"
  >
    <DataDetailList
      :formDate="formDate"
      :optionKey="currentDetailItemKey"
      :type="currentDetailType"
    />
  </ActionSheet>
</template>
<style lang="scss" scoped>
.list-wrap {
  margin-top: 6px;
  padding: 38px 26px;
  background-color: #fff;

  .list-title {
    font-size: 34px;
    font-weight: bold;
    color: #222222;
  }
}
</style>
